const { Observable } = require('rxjs');

const isObservable = require('./is-observable');
const isPromise = require('./is-promise');

/**
 * Convert the provided value to an observable sequence
 * @param {Observable|Promise|any} value Value to convert to an observable
 * @returns {Observable} Observable sequence
 */
function toObservable(value) {
  if (value === undefined) {
    return Observable.empty();
  } else if (isObservable(value)) {
    return cloneObservable(value);
  } else if (isPromise(value)) {
    return Observable.fromPromise(value);
  }
  return Observable.of(value);
}

module.exports = toObservable;

function cloneObservable(stream) {
  return Observable.from(stream).do(() => {});
}
